/**
 * `api_tokens` — accès par jeton (base plateforme, 4.1 ; API à jetons, 7.8).
 */
import { z } from 'zod';
import { CHAMPS_DOCUMENT, idSchema, withAudit } from './commun.js';
/** Portées accordées à un jeton, au grain de la ressource. */
export const PORTEES_JETON = [
    'artworks:read',
    'artworks:write',
    'artists:read',
    'exhibitions:read',
    'contacts:read',
    'contacts:write',
    'inquiries:write',
    'site:read',
];
export const porteeJetonSchema = z.enum(PORTEES_JETON);
export const apiTokenSchema = withAudit(z.object({
    _id: idSchema,
    galerieId: idSchema,
    compteId: idSchema.optional(),
    nom: z.string(),
    prefixe: z.string().length(8),
    jetonHash: z.string(),
    portees: z.array(porteeJetonSchema).min(1),
    expireLe: z.date().optional(),
    dernierUsage: z.date().optional(),
    revoqueLe: z.date().optional(),
}));
export const apiTokenCreationSchema = apiTokenSchema.omit({
    ...CHAMPS_DOCUMENT,
    prefixe: true,
    jetonHash: true,
    dernierUsage: true,
    revoqueLe: true,
});
export const apiTokenMiseAJourSchema = apiTokenCreationSchema.omit({ galerieId: true }).partial();
//# sourceMappingURL=api-tokens.js.map